import { render, staticRenderFns } from "./ImsCustomersList.vue?vue&type=template&id=0ebd26fe&"
import script from "./ImsCustomersList.vue?vue&type=script&lang=js&"
export * from "./ImsCustomersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports